import React from 'react';

export default function TabBar({ tabs, activeTab, onTabChange }) {
  return (
    <div className="border-b border-app-border">
      <nav className="flex gap-6 overflow-x-auto sm:gap-8" role="tablist">
        {tabs.map((tab, i) => (
          <button
            key={tab}
            role="tab"
            aria-selected={activeTab === i}
            onClick={() => onTabChange(i)}
            className={`
              whitespace-nowrap border-b-2 px-1 py-3 text-[11px] uppercase tracking-[0.08em]
              transition-[color,border-color] duration-150
              ${activeTab === i
                ? 'border-navy text-slate-800 font-semibold'
                : 'border-transparent text-slate-400 font-medium hover:text-slate-500'
              }
            `}
          >
            {tab}
          </button>
        ))}
      </nav>
    </div>
  );
}
